export const activityStateEnum = {
    ENTERED: 3,
    VALIDATED: 5,
    SEMIVALIDATED: 6,
    VALIDATION: 7,
    REPORTFILLED: 10,
    REPORT: 20,
    PLANNINGSENT: 22,
    PLANNING: 23,
    NEEDSIMPORTED: 24,
    NEEDSSENT: 25,
    NEEDSFILLED: 27,
    NEEDS: 30,
};

export const activityTypeEnum = {
    SITE: 1,
    TRUCK: 2,
    OTHER: 3,
};

export const stepModeEnum = {
    NEEDS: 1,
    PLANNING: 5,
    REPORT: 10,
};
